import React from 'react';
import PropTypes from 'prop-types';

import Box from 'ravenjs/lib/Box';
import Typography from 'ravenjs/lib/Typography';
import { sanitizeMarkup } from 'ravenjs/utils/sanitize';

/**
 * Simple banner component to display a warning or message to the user.
 *
 * @method      ProductBanner
 * @param       {Object}      props The component props
 * @constructor
 */
function ProductBanner(props) {
    const { text, color, ...rest } = props;

    return (
        text && (
            <Box
                backgroundColor="rgba(245, 127, 23, 0.2)"
                borderColor="rgba(245, 127, 23, 0.5)"
                borderRadius="0"
                margin="10px"
                width="auto"
                {...rest}
            >
                <Typography
                    as="span"
                    color={color}
                    dangerouslySetInnerHTML={sanitizeMarkup(text)}
                />
            </Box>
        )
    );
}

ProductBanner.propTypes = {
    color: PropTypes.string,
    text: PropTypes.string,
};

ProductBanner.defaultProps = {
    color: 'rgb(245, 127, 23)',
    text: null,
};

export default ProductBanner;
